import { render, staticRenderFns } from "./benefitactivities.vue?vue&type=template&id=45bd694c&scoped=true&"
import script from "./benefitactivities.vue?vue&type=script&lang=js&"
export * from "./benefitactivities.vue?vue&type=script&lang=js&"
import style0 from "./benefitactivities.vue?vue&type=style&index=0&id=45bd694c&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd694c",
  null
  
)

export default component.exports